import { Component, inject, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pds-menu-card',
  standalone: false,
  templateUrl: './menu-card.component.html',
  styleUrls: ['./menu-card.component.scss'],
})
export class MenuCardComponent {
  routerLink = input<string | string[]>('');
  relative = input<boolean | null>(null);
  titleAttribute = input<string | null>();
  title = input.required<string>();
  subtitle = input.required<string | null>();

  route = inject(ActivatedRoute);
}
